import { AxiosRequestConfig } from "axios";
import Cookies from "js-cookie";
import { cognitoConfig, apiConfig } from "../config";

const cognitoServiceProvider = "CognitoIdentityServiceProvider";
const lastAuthUser = "LastAuthUser";
const refresh = async (
  config: AxiosRequestConfig
): Promise<AxiosRequestConfig> => {
  const cognitoPrefix =
    cognitoServiceProvider + "." + cognitoConfig.clientId + ".";
  const userName = localStorage.getItem(cognitoPrefix + lastAuthUser);
  const refreshToken = localStorage.getItem(
    cognitoPrefix + userName + "." + "refreshToken"
  );
  const tokenExpTime = localStorage.getItem("tokenExpTime");
  let token = localStorage.getItem("tooderAccessToken");
  //   console.log("tokenExpTime : ", tokenExpTime);
  //   console.log("refreshToken : ", refreshToken);
  // console.log("apiConfig : ", apiConfig)
  if (tokenExpTime != null) {
    const expireAt = new Date(parseInt(tokenExpTime));
    const curTime = new Date();
    if (expireAt <= curTime && refreshToken) {
      const res = await fetch(`${cognitoConfig.loginUrl}/oauth2/token`, {
        method: "POST",
        headers: new Headers({
          "content-type": "application/x-www-form-urlencoded",
        }),
        body: Object.entries({
          grant_type: "refresh_token",
          client_id: cognitoConfig.clientId,
          redirect_uri: window.location.origin,
          refresh_token: refreshToken,
        })
          .map(([k, v]) => `${k}=${v}`)
          .join("&"),
      });
      if (res.ok) {
        const newTokens = await res.json();
        const { access_token, expires_in } = newTokens;
        console.log("refresh token success !! ", newTokens);
        localStorage.setItem(
          "tokenExpTime",
          String(new Date().getTime() + expires_in * 1000)
        );
        localStorage.setItem("tooderAccessToken", access_token);
        token = access_token;
      } else {
        console.log("res : ", res);
      }
    }
  }
  config.headers["Authorization"] = token;
  return config;
};

const refreshErrorHandle = (err: any) => {
  console.log("refreshErrorHandle : ", err);
  try {
    Cookies.remove("refreshToken");
  } catch (e) {
    console.log("refreshErrorHandle error : ", refreshErrorHandle);
  }
};

export { refresh, refreshErrorHandle };
